import request from "../utils/request";

/**
 * Get current user's sessions
 * @returns {Promise} Sessions list
 */
export function getMySessions() {
    return request.get("/sessions/my");
}

/**
 * Get all sessions for the site (Admin only)
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number
 * @param {number} params.perPage - Items per page
 * @param {boolean} params.activeOnly - Filter active sessions only
 * @param {string} params.userId - Filter by user ID
 * @returns {Promise} Sessions list with pagination
 */
export function getAllSessions(params = {}) {
    return request.get("/sessions/all", { params });
}

/**
 * Revoke current user's own session
 * @param {string} sessionId - Session ID to revoke
 * @returns {Promise} Revoke result
 */
export function revokeMySession(sessionId) {
    return request.post("/sessions/" + sessionId + "/revoke");
}

/**
 * Revoke all of current user's sessions except current
 * @returns {Promise} Revoke result
 */
export function revokeAllMySessions() {
    return request.post("/sessions/revoke-all-mine");
}

/**
 * Admin revoke any session
 * @param {string} sessionId - Session ID to revoke
 * @param {string} reason - Optional reason for revocation
 * @returns {Promise} Revoke result
 */
export function adminRevokeSession(sessionId, reason) {
    return request.post("/sessions/admin/" + sessionId + "/revoke", { reason });
}

/**
 * Admin revoke all sessions for a specific user
 * @param {string} userId - Target user ID
 * @param {string} reason - Optional reason for revocation
 * @returns {Promise} Revoke result
 */
export function adminRevokeUserSessions(userId, reason) {
    return request.post("/sessions/admin/revoke-user/" + userId, { reason });
}

/**
 * Refresh token
 * @param {string} refreshToken - Current refresh token
 * @returns {Promise} New tokens
 */
export function refreshToken(refreshToken) {
    return request.post("/sessions/refresh", { refreshToken });
}

/**
 * Validate current token
 * @returns {Promise} Validation result
 */
export function validateToken() {
    return request.get("/sessions/validate");
}

/**
 * Generate unique browser session ID for device fingerprinting
 * @returns {string} Browser session ID
 */
export function getBrowserSessionId() {
    let sessionId = localStorage.getItem("browserSessionId");
    if (!sessionId) {
        sessionId = "bs_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
        localStorage.setItem("browserSessionId", sessionId);
    }
    return sessionId;
}
